module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1179.41f03754.png";